(function(){
  function toast(msg){
    var t=document.querySelector('.lz-toast');
    if(!t){t=document.createElement('div');t.className='lz-toast';document.body.appendChild(t);}
    t.textContent=msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer=setTimeout(function(){t.classList.remove('is-visible');},2200);
  }

  function applyCount(count){
    var fab=document.querySelector('.lz-fab-cart');
    if(fab){
      var fabBadge=fab.querySelector('[data-lz-fab-count]');
      if(fabBadge)fabBadge.textContent=count;
      fab.classList.toggle('has-items',count>0);
    }
    var headerCart=document.querySelector('[data-lz-header-cart]');
    if(headerCart){
      var headerBadge=headerCart.querySelector('[data-lz-header-count]');
      if(headerBadge){
        headerBadge.textContent=count;
        headerBadge.hidden=count===0;
      }
    }
  }

  function syncCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        applyCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('lz:cart:updated',{detail:{item_count:cart.item_count}}));
      })
      .catch(function(){});
  }

  document.addEventListener('lz:cart:updated',function(e){applyCount(e.detail.item_count);});

  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-lz-quickbuy]');
    if(!btn)return;
    e.preventDefault();
    if(btn.classList.contains('is-loading'))return;
    var variantId=btn.getAttribute('data-variant-id');
    btn.classList.add('is-loading');
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:variantId,quantity:1}]})
    }).then(function(r){return r.json();}).then(function(){
      return fetch('/cart.js').then(function(r){return r.json();});
    }).then(function(cart){
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      var label=btn.querySelector('span');
      if(label){var prev=label.textContent;label.textContent='Añadido';setTimeout(function(){label.textContent=prev;btn.classList.remove('is-added');},1600);}
      applyCount(cart.item_count);
      toast('Añadido al carrito · '+cart.item_count+' artículo(s)');
    }).catch(function(){
      btn.classList.remove('is-loading');
      toast('No se pudo añadir. Prueba desde la ficha del producto.');
    });
  });

  // Sincroniza el contador cuando la página del carrito nativa cambia cantidad/borra artículos
  var cartContainer=document.querySelector('#main-cart-items, cart-items, .cart__items');
  if(cartContainer){
    var mo=new MutationObserver(function(){
      clearTimeout(cartContainer._lzSyncTimer);
      cartContainer._lzSyncTimer=setTimeout(syncCartCount,350);
    });
    mo.observe(cartContainer,{childList:true,subtree:true});
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('cart-remove-button, .quantity__button, [name="minus"], [name="plus"]')){
      setTimeout(syncCartCount,500);
    }
  });
  document.addEventListener('change',function(e){
    if(e.target.matches && e.target.matches('.quantity__input, input[name="updates[]"]')){
      setTimeout(syncCartCount,500);
    }
  });

  syncCartCount();
})();
